import { render, staticRenderFns } from "./DsxxPage.vue?vue&type=template&id=3cfeaf22&scoped=true"
import script from "./DsxxPage.vue?vue&type=script&lang=js"
export * from "./DsxxPage.vue?vue&type=script&lang=js"
import style0 from "./DsxxPage.vue?vue&type=style&index=0&id=3cfeaf22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfeaf22",
  null
  
)

export default component.exports